import "date-fns";
const isEqualTimeSlot = (a, b) => a === b || !!a && !!b && a.from.getTime() === b.from.getTime() && a.until.getTime() === b.until.getTime();
export {
  isEqualTimeSlot
};
//# sourceMappingURL=utils.js.map
